import { Chips } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import './PositionLineContainer.scss';

const PositionLineContainer = ({ positionLine, setValues, values }) => {
  const hasData = positionLine?.length;

  const deletePositionLine = (labelValue) => {
    setValues({
      ...values,
      posicionesLineas: positionLine?.filter((e) => e?.label !== labelValue)
    });
  };

  return (
    <div className={`position-line-container${hasData ? '' : '-disabled'}`}>
      {hasData ? (
        <Chips
          data={positionLine}
          onDelete={(chip) => deletePositionLine(chip.label)}
          variant="dark"
        />
      ) : (
        <p className="place-holder">Posición y linea</p>
      )}
    </div>
  );
};

export default PositionLineContainer;

PositionLineContainer.propTypes = {
  positionLine: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ).isRequired,
  setValues: PropTypes.func.isRequired, // Add this line
  values: PropTypes.shape({}).isRequired // Also add a validation for the 'values' prop
};
